import loadable from '@loadable/component'

export const Ticker = loadable(() => import('./Ticker'))
